import React from 'react';

import AnnouncementConsumer from './AnnouncementConsumer';

const withAnnouncement = (WrappedComponent) => {
  const HOC = ({ ...restProps }) => {
    return (
      <AnnouncementConsumer>
        {(context) => <WrappedComponent {...restProps} announcementContext={context} />}
      </AnnouncementConsumer>
    );
  };
  return HOC;
};

export { withAnnouncement };
